"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const faChevronRight_1 = require("@fortawesome/pro-regular-svg-icons/faChevronRight");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const react_i18next_1 = require("react-i18next");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        container: {
            marginHorizontal: 12
        },
        item: {
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            paddingLeft: 0,
            paddingVertical: 8
        },
        itemText: {
            flex: 4,
            fontSize: 16,
            fontWeight: '500'
        },
        itemActionIcon: {
            flex: 1,
            textAlign: 'right'
        },
        separator: {
            backgroundColor: THEME.Black + '1A',
            height: 1,
            marginHorizontal: -12
        }
    });
};
const AppMenuListItem = (props) => {
    let p = {
        ...props,
        actionIcon: props.actionIcon ?? faChevronRight_1.faChevronRight,
        onPress: props.onPress ?? (() => { })
    };
    const { t } = (0, react_i18next_1.useTranslation)('common');
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { accessible: true, "aria-label": props.name, style: ({ pressed }) => [(pressed ? STYLES.pressedOpacity : null)], onPress: (e) => p.onPress(p.id), children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.item, children: [props.icon
                    &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginRight: 10 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: 24, color: THEME.Primary }) }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: [styles.itemText, { color: p.color ?? THEME.Text, marginVertical: 4 }], children: p.name }), props.actionIcon
                    &&
                        (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: p.color ?? THEME.Primary, icon: p.actionIcon, size: 20, style: { outlineWidth: 0 } })
                    ||
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { children: size != 'sm'
                                &&
                                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                            marginVertical: 4, marginHorizontal: 2, flexDirection: 'row', alignItems: 'center',
                                            backgroundColor: THEME.Outline + '11', paddingVertical: 8, paddingHorizontal: 16, borderRadius: 3
                                        }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: p.color ?? THEME.Primary, fontSize: 16, fontWeight: '500', marginRight: 8, marginTop: -2 }, children: t('common:text.view') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ArrowRight, size: size != 'sm' ? 18 : 24, color: THEME.Primary, style: { outlineWidth: 0 } })] })
                                ||
                                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                            marginVertical: 6, marginHorizontal: 4, flexDirection: 'row', alignItems: 'center'
                                        }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ArrowRight, size: size != 'sm' ? 18 : 24, color: p.color ?? THEME.Primary, style: { outlineWidth: 0 } }) }) })] }) }));
};
const AppMenuList = (props) => {
    const styles = useStyles();
    const validChildren = react_1.default.Children.toArray(props.children).filter(react_1.default.isValidElement);
    let childCount = react_1.default.Children.count(validChildren);
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.container, children: react_1.default.Children.map(validChildren, (child, index) => (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [react_1.default.isValidElement(child) && react_1.default.cloneElement(child), (index < childCount - 1) &&
                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.separator })] })) }));
};
AppMenuList.Item = AppMenuListItem;
exports.default = AppMenuList;
